import { render, staticRenderFns } from "./feeDialog.vue?vue&type=template&id=0b98e166&scoped=true&"
import script from "./feeDialog.vue?vue&type=script&lang=js&"
export * from "./feeDialog.vue?vue&type=script&lang=js&"
import style0 from "./feeDialog.vue?vue&type=style&index=0&id=0b98e166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b98e166",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b98e166')) {
      api.createRecord('0b98e166', component.options)
    } else {
      api.reload('0b98e166', component.options)
    }
    module.hot.accept("./feeDialog.vue?vue&type=template&id=0b98e166&scoped=true&", function () {
      api.rerender('0b98e166', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/merchantMy/feeDialog.vue"
export default component.exports